import styled from 'styled-components';

import { getScreenHeight } from '@utils/screen';

interface FatalErrorWrapperProps {
  pageOffSetInRem: number;
}

export const FatalErrorWrapper = styled.div<FatalErrorWrapperProps>`
  height: ${({ pageOffSetInRem }) => getScreenHeight() - pageOffSetInRem}rem;
`;
